import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_grid_table_cell = _resolveComponent("grid-table-cell")

  return (_openBlock(), _createBlock(_component_grid_table_cell, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, { class: "gfua-tree__leaf-wrapper" }), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass($options.classes)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2 /* CLASS */)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */))
}